export const LOAD_BRIEFCASES = "LOAD_BRIEFCASES";
export const LOADING_BRIEFCASES = "LOADING_BRIEFCASES";
export const ERROR_BRIEFCASES = "ERROR_BRIEFCASES";
